import { Dropdown, useInputValidation } from '@landsbankinn/ui';
import React from 'react';
import { SmartBookingCustomerType } from '../../../../../__generated__/globalTypes';
import { useAppointmentContext } from '../../../book-appointment/BookAppointment';

const options = [
  {
    value: SmartBookingCustomerType.Person,
    label: 'Einstaklingsþjónusta',
  },
  {
    value: SmartBookingCustomerType.Company,
    label: 'Fyrirtækjaþjónusta',
  },
];

export function SelectCustomerType() {
  const { dispatch, state } = useAppointmentContext();

  const [ref, isValid] = useInputValidation(state.customerType, [
    {
      validation: (value) => value !== undefined,
    },
  ]);

  return (
    <Dropdown
      isValid={isValid}
      variant="noBorder"
      label="Veldu tegund"
      labelVariant="aboveInput"
      errorMessageVariant="insideInput"
      options={options}
      buildOption={(option) => option}
      value={options.find((o) => o.value === state.customerType)}
      onChange={(value) => {
        dispatch?.({
          type: 'selectCustomerType',
          customerType: SmartBookingCustomerType[(value as any)['value']],
        });
      }}
    />
  );
}
